import { TileSection } from 'foundations-components/transitional/components/Tile';
import { Text } from 'foundations-components/components/Text';
import { Tile } from 'foundations-components/transitional/components/Tile';
import RecommendedPopularFeaturePanelImage from './RecommendedPopularFeaturePanelImage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecommendedPopularFeatureCard = ({
  featureRecord,
  apiName
}) => {
  return /*#__PURE__*/_jsxs(Tile, {
    marginBlockStart: "0",
    blockSize: "100%",
    children: [/*#__PURE__*/_jsx(TileSection, {
      padding: "600",
      children: /*#__PURE__*/_jsx(RecommendedPopularFeaturePanelImage, {
        featureRecord: featureRecord
      })
    }), /*#__PURE__*/_jsx(TileSection, {
      paddingInline: "600",
      paddingBlockEnd: "600",
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h5",
          marginBlockEnd: "200",
          children: featureRecord.displayName
        }), /*#__PURE__*/_jsx(Text, {
          as: "p",
          marginBlockEnd: "0",
          children: featureRecord.descriptions[apiName]
        })]
      })
    })]
  });
};
export default RecommendedPopularFeatureCard;